import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryDetailContent from '../../containers/accessory-detail-content';
import AccessoryInfoContainer from '../../blocks/accessory-info-container';
import Cta from '../../containers/cta';

const AccessoryDetailContentBlock = props => <AccessoryDetailContent {...props} />;
AccessoryDetailContentBlock.displayName = 'AccessoryDetailContent';

export default withDynamicComponents({
  componentWhitelist: [
    AccessoryInfoContainer,
    Cta
  ],
  mapInputToOutput: [
    
  ],
})(AccessoryDetailContentBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-detail-content/index.jsx